import { ConsumptionInterface} from '../../models/consumption.interface';

export interface ConsumptionInterfaceState {
  consumption: ConsumptionInterface;
}

export const initialConsumptionState: ConsumptionInterfaceState = {
  consumption: null
};
